import { useCallback, useEffect } from "react";
import { useCloseSession } from "@src/api/useCloseSession";
import Container from "@src/components/shared/Container";
import useZustandStore from "@src/helpers/zustand";

function Identification() {
  const closeMutation = useCloseSession();

  const { data: globalState } = useZustandStore((state) => state);

  const handleMutation = useCallback(() => {
    if (globalState.identomat.sessionId && globalState.apiKey) {
      closeMutation.mutate({
        sessionId: globalState.identomat.sessionId,
        contextId: globalState.contextId,
        apiKey: globalState.apiKey,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalState.identomat.sessionId, globalState.apiKey]);

  const handleMessage = useCallback(
    (e: MessageEvent) => {
      if (e.origin !== "https://widget.identomat.com") return;
      if (e.data !== "DONE") return;
      handleMutation();
    },
    [handleMutation],
  );

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [handleMessage]);

  return (
    <Container>
      <iframe
        allow="camera *;"
        allowFullScreen
        scrolling="yes"
        src={globalState.identomat.frameUrl}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          height: "100%",
          width: "100%",
          zIndex: 999999,
        }}
        title="identomat"
      />
    </Container>
  );
}

export default Identification;
